import { NgbConfig } from '@ng-bootstrap/ng-bootstrap';

/**
 * Keeps the behaviour ng-bootstrap 7.0 had after the move to a current release (copied from lifemaan-web, which made
 * the same 7 → 20 move): no fade/slide animations on modals and backdrops — 7.0 had none; 8.0 turned them on.
 *
 * lifemaan-web also restores 7.x's tooltip `auto` placement order; this app has no `ngbTooltip`, so that half is not
 * carried over.
 *
 * Called once at start-up (provideAppInitializer in app.config.ts); the config is a root singleton, so this is global.
 */
export function applyNgBootstrapLegacyDefaults(ngbConfig: NgbConfig): void {
    ngbConfig.animation = false;
}
